/**
 * Copyright 2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export const DEFAULT_PAGE_SIZE = 20;
export const LOAD_MORE_INCREMENT = 50;
